module.exports = __webpack_public_path__ + "img/no-photo.4d9e50f1.svg";